<!--
 * @Author: wangzhu
 * @Date: 2021-12-29 14:51:36
 * @LastEditTime: 2022-12-29 16:06:13
 * @LastEditors: wangzhu10 wangzhu10@jd.com
-->
<template>
    <div id="page6-wrapper">
       <!-- <img class="page6-title" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-26-18-22AGpJryFrlHjTQIc.png"/> -->
        <div class="page6-content animate__animated  animate__fadeIn">
          <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-21-19-44xn57fRr44BedswCk6.png" class="start-icon animate__animated  animate__pulse animate__infinite">
          这一年你<template v-if="reportData.upNum">送出了<span class="report-num"> {{ reportData.upNum }} </span>个点赞<br></template>
          <template v-if="reportData.replyNum">发表了<span class="report-num"> {{ reportData.replyNum }} </span>条评论<br></template>
          <template v-if="reportData.favorNum">收藏了<span class="report-num"> {{ reportData.favorNum }} </span>篇文章/畅聊<br></template>
          <template v-if="reportData.followingNum">关注了<span class="report-num"> {{ reportData.followingNum }} </span>人<br></template>

          互相勉励，共同进步<br>
          是你让他们的分享得到了回应<br>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page6',
    props: {
        reportData: {
            required: true,
            default: () => {},
        },
    },
    computed: {
        forumData() {
            const res = {
                post: 0,
                read: 0,
                percentage: 0
            };
            for (let i = 0; i < this.reportData.forumData.length; i++) {
                const item = this.reportData.forumData[i];
                res.post += item.num;
                res.read += item.viewNum;
                res.percentage = item.percentage > res.percentage ? item.percentage.slice(0, 4) : res.percentage;
            }
            return res;
        },
    },
    methods: {
        handleNext() {
            this.$emit('next');
        },
        handlePre() {
            this.$emit('pre');
        },
    },
};
</script>

<style lang="less" scoped>
#page6-wrapper {
  height: 100vh;
  width: 100%;
  background-image: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-16-22bys22mAcOKqDTy8J.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // padding: 0 20px;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;

  .page6-content {
    // padding-top: 30vh;
    font-size: 0.4rem;
    font-weight: bold;
    // margin: 5vh auto 0;
    // width: 75%;
    line-height: 2.8;
    // min-height: 40vh;
    color: #FAFAD7;
    margin-top: 3.5rem;
    // padding: 36px 36px;
    // text-shadow: 1px 1px #f4e8e8;
    // background: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-26-18-43kX80N43JidSQXXrz.png');
    // background-size: 100% 100%;
    box-sizing: border-box;
  }

  .page-title {
    width: 100px;
    color: #fff;
    background: #2D97E1;
    border-radius: 4px;
    margin-bottom: 40px;
    font-weight: 500;
    line-height: 1;
    padding: 6px 0;
    position: relative;

    &:after {
      position: absolute;
      display: block;
      content: '';
      width: 300px;
      height: 4px;
      bottom: -4px;
      border-radius: 4px;
      background: #D9F0F9;
    }
  }

  .sprite {
    position: absolute;
    top: 10px;
    left: 150px;
    width: 3.92rem;
    height: 2.5rem;
    background-repeat: no-repeat;
    background-image: url(https://storage.360buyimg.com/iast-agent/reportSprite2.png);
    background-size: 100% 100%;
    -webkit-transform-origin: 0 100%;
    -webkit-animation: hand 1s infinite ease-in-out alternate;
  }

  @keyframes hand {
    0% {
      -webkit-transform: rotate(90deg);
    }

    100% {
      -webkit-transform: rotate(135deg);
    }
  }

  .report-num {
    color: #f1f406;
    font-weight: 500;
    font-size: 0.55rem;
  }
  .start-icon {
    position: absolute;
    top: 3.5rem;
    left: 5vw;
    width: 50px;
  }
  .page6-title {
        // width: 60%;
        height: 1.5rem;
        margin-top: 10vh;
    }
}
@media screen and (min-width: 1980px) {
            #page6-wrapper {
                .page6-content {
                    margin-top: 24vh;
                }
            }
            }
</style>
